import { SelectListWrapper } from 'components/ui/SelectList/SelectListStyles';
import styled from 'styled-components';
import { acceptgreen, black, reviewLine, warningred, yellow } from 'styles/Colors';

export const Indicator = styled.span`
  width: 5px;
  height: 30px;
  border-radius: 15px;
  background-color: ${acceptgreen};
  margin-right: 14px;
  &.error {
    background-color: ${warningred};
  }
  &.warmup {
    background-color: ${yellow};
  }
`;

export const ExpandIconWrapper = styled.div`
  margin-left: auto;
  margin-right: 9px;
  transition: all 0.3s;
  &.expanded {
    transform: rotate(180deg);
  }
  svg {
    cursor: pointer;
  }
`;

export const StatusCellWrapper = styled.div`
  user-select: none;
  display: flex;
  padding-left: 10px;
  justify-content: left;
  align-items: center;
  border-color: rgba(0, 0, 0, 0);
  font-size: 15px;
  font-family: 'Lato';
  font-weight: bold;
  letter-spacing: 0.42px;
  color: #000000;
  &.hidden {
    display: none !important;
  }
  ${SelectListWrapper} {
    position: absolute;
    z-index: 100;
    right: 6px;
    top: 50px;
    max-width: 160px;
    font-family: Lato;
    padding-bottom: 0;
  }
`;

export const Line = styled.span`
  width: 100%;
  height: 1px;
  background: ${reviewLine};
  position: absolute;
  left: 0;
  bottom: 56px;
`;

export const Error = styled.div`
  font-size: 15px;
  letter-spacing: 0.42px;
  color: ${warningred};
  margin-bottom: 7px;
`;

export const LiveOrWarmup = styled.div`
  text-align: center;
  padding: 0;
  height: 60px;
  line-height: 60px;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.5px;
  color: ${black};
`;
